import { TemplateConfig } from '../types';

export const futureLoverSpreadConfig: TemplateConfig = {
  id: 'future-lover-spread',
  name: '未来恋人牌阵',
  description: '预判未来恋人的类型与感情中的障碍和重点',
  cardCount: 6,
  
  fieldDefaults: {
    title: '未来恋人牌阵',
    customerQuestion: '预判未来恋人的类型与感情中的障碍和重点，帮助我更快锁定下一任，经营下一段感情。',
    cardPlaceholders: [
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 2 列第 1 张牌'
    ],
    cardInfos: [
      '对方是什么类型',
      '对方已经出现了吗',
      '我和对方之间的阻碍',
      '我和对方的相处模式',
      '如何与对方相遇或是再次相遇',
      '指引及建议'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#f759ab',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};